import { getBorderRadius, getBorderWidth, getBorderStyle, getOutlineWidth, getOutlineStyle, getOutlineOffset, } from '../../borders/borders.alias';
import { getBackgroundColor, getBorderColor, getColor, getOutlineColor, } from '../../colors/colors.alias';
import { getHeight } from '../../sizes/sizes.alias';
import { getFontFamily, getFontSize, getFontStyle, getLineHeight, } from '../../typography/typography.alias';
import getIcons from '../../icons/icons.alias';
import { constants as Label } from '../Label';
import { constants as Icon } from '../Icon';
import { constants as InlineMessage } from '../InlineMessage';
import { constants as Menu } from '../Menu';
import { VARIANT_DEFAULT, VARIANT_WITH_NATIVE_MENU, ELEMENT_LABEL, ELEMENT_BOX, ELEMENT_VALUE, ELEMENT_OPEN_ICON, ELEMENT_INLINE_MESSAGE, ELEMENT_MENU, ELEMENT_PLACEHOLDER, INTERACTION_STATE_HOVER, INTERACTION_STATE_FOCUS_VISIBLE, DATA_STATE_INVALID, DATA_STATE_VALID, INTERACTION_STATE_OPEN, DATA_STATE_READ_ONLY, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Select',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_WITH_NATIVE_MENU,
    },
    elements: {
        ELEMENT_LABEL,
        ELEMENT_BOX,
        ELEMENT_VALUE,
        ELEMENT_OPEN_ICON,
        ELEMENT_INLINE_MESSAGE,
        ELEMENT_MENU,
        ELEMENT_PLACEHOLDER,
    },
    interactionStates: {
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
        INTERACTION_STATE_OPEN,
    },
    dataStates: {
        DATA_STATE_VALID,
        DATA_STATE_INVALID,
        DATA_STATE_READ_ONLY,
    },
});
export default function getSelect(transformer, config) {
    const borderStyle = getBorderStyle(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    const borderWidth = getBorderWidth(transformer, config);
    const color = getColor(transformer, config);
    const fontFamily = getFontFamily(transformer, config);
    const fontSize = getFontSize(transformer);
    const lineHeight = getLineHeight(transformer);
    const height = getHeight(transformer);
    const outlineOffset = getOutlineOffset(transformer, config);
    const outlineWidth = getOutlineWidth(transformer, config);
    const outlineColor = getOutlineColor(transformer, config);
    const outlineStyle = getOutlineStyle(transformer, config);
    const borderRadius = getBorderRadius(transformer, config);
    const backgroundColor = getBackgroundColor(transformer, config);
    const icons = getIcons();
    const fontStyle = getFontStyle(transformer, config);
    return Object.freeze({
        constants,
        elements: {
            [ELEMENT_LABEL]: {
                components: {
                    [Label.NAME]: {
                        variant: Label.variants.VARIANT_FORM,
                    },
                },
            },
            [ELEMENT_BOX]: {
                styles: {
                    height: height.form.input.default.value,
                    borderRadius: borderRadius.form.input.value,
                    borderWidth: borderWidth.container.default.value,
                    borderColor: borderColor.form.input.default.value,
                    borderStyle: borderStyle.form.select.box.value,
                    backgroundColor: backgroundColor.form.input.default.value,
                },
            },
            [ELEMENT_VALUE]: {
                styles: {
                    fontFamily: fontFamily.body.value,
                    fontSize: fontSize.body.m.value,
                    lineHeight: lineHeight.form.input.get(fontSize.body.m.value),
                    color: color.text.default.value,
                },
            },
            [ELEMENT_OPEN_ICON]: {
                styles: {
                    color: color.form.select.icon.value,
                },
                components: {
                    [Icon.NAME]: {
                        variant: Icon.variants.VARIANT_MEDIUM,
                        name: icons.form.select.open.value,
                    },
                },
            },
            [ELEMENT_INLINE_MESSAGE]: {
                components: {
                    [InlineMessage.NAME]: {
                        variant: InlineMessage.variants.VARIANT_DEFAULT,
                    },
                },
            },
            [ELEMENT_MENU]: {
                components: {
                    [Menu.NAME]: {
                        variant: Menu.variants.VARIANT_DEFAULT,
                    },
                },
            },
            [ELEMENT_PLACEHOLDER]: {
                styles: {
                    color: color.form.placeholder.value,
                    fontStyle: fontStyle.form.placeholder.value,
                },
            },
        },
        interactionStates: {
            [INTERACTION_STATE_HOVER]: {
                elements: {
                    [ELEMENT_BOX]: {
                        styles: {
                            borderColor: borderColor.form.input.interactionStates[INTERACTION_STATE_HOVER].value,
                        },
                    },
                },
            },
            [INTERACTION_STATE_FOCUS_VISIBLE]: {
                elements: {
                    [ELEMENT_BOX]: {
                        styles: {
                            outlineOffset: outlineOffset.default.value,
                            outlineStyle: outlineStyle.default.value,
                            outlineWidth: outlineWidth.default.value,
                            outlineColor: outlineColor.default.interactionStates[INTERACTION_STATE_FOCUS_VISIBLE].value,
                        },
                    },
                },
            },
        },
        dataStates: {
            [DATA_STATE_INVALID]: {
                elements: {
                    [ELEMENT_BOX]: {
                        styles: {
                            borderColor: borderColor.form.input.dataStates[DATA_STATE_INVALID].value,
                            borderWidth: borderWidth.form.input.dataStates[DATA_STATE_INVALID].value,
                        },
                    },
                },
            },
        },
    });
}
